import client from "api/client";

// formsApi — website-scoped /websites/{websiteId}/forms. The website comes from
// the path, so `website_id` is not needed in query params or bodies.

// GET /websites/{id}/forms — paginated. Returns a normalized { items, total, hasMore }.
export const listForms = async (websiteId, { limit = 1000, offset = 0, search } = {}) => {
  const params = { limit, offset, sort_by: "created_at", sort_desc: true };
  if (search) params.search = search;
  const { data } = await client.get(`/websites/${websiteId}/forms`, { params });
  return { items: data.items ?? [], total: data.total ?? 0, hasMore: !!data.has_more };
};

export const getForm = async (websiteId, id) => {
  const { data } = await client.get(`/websites/${websiteId}/forms/${id}`);
  return data;
};

export const createForm = async (websiteId, payload) => {
  const { data } = await client.post(`/websites/${websiteId}/forms`, payload);
  return data;
};

export const updateForm = async (websiteId, id, payload) => {
  const { data } = await client.put(`/websites/${websiteId}/forms/${id}`, payload);
  return data;
};

export const deleteForm = async (websiteId, id) => {
  await client.delete(`/websites/${websiteId}/forms/${id}`);
};

export const activateForm = async (websiteId, id) => {
  await client.post(`/websites/${websiteId}/forms/${id}/activate`);
};

export const deactivateForm = async (websiteId, id) => {
  await client.post(`/websites/${websiteId}/forms/${id}/deactivate`);
};

// GET /websites/{id}/forms/{formId}/submissions/export — returns a CSV blob.
export const exportFormSubmissions = async (
  websiteId,
  formId,
  { startDate, endDate, status, limit } = {}
) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  if (status) params.status = status;
  if (limit) params.limit = limit;

  const response = await client.get(`/websites/${websiteId}/forms/${formId}/submissions/export`, {
    params,
    responseType: "blob",
  });
  return response.data;
};
